import MentorClinicAssociations from 'src/supportPortal/components/common/mentor/clinicAssociations/MentorClinicAssociations'

export default function TherapistClinics() {
  return (
    <MentorClinicAssociations
      getAssociatedBrandsApiSignature="/api/secure/cc/support/therapists/clinic-associations"
      getSelectedMentorApiSignature="/api/secure/cc/support/therapists/by-slug"
      hidePayoutReports
      hideEngagementModels
      hidePayoutInvoices
      showScopedLaunchers
      scopedActionEntityType="therapists"
    />
  )
}
